import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function RoleGuard({ allow }) {
  const { role } = useAuth();
  const allowed = Array.isArray(allow) ? allow : [allow];
  if (!role || !allowed.includes(role)) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
